var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.362198 8.61421L7.70373 0.377694C7.92712 0.125879 8.21378 0 8.50068 0C8.78743 0 9.07399 0.125937 9.29762 0.377694L16.6392 8.61421C17.1028 9.13914 17.1222 10.0134 16.6826 10.5671C16.2419 11.1248 15.5051 11.1445 15.0433 10.6211L8.49874 3.23069L1.95415 10.6211C1.49241 11.1445 0.760669 11.1249 0.316796 10.5671C-0.122247 10.0134 -0.102927 9.13914 0.362198 8.61421Z",
    fill: "#100E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.22c4ef4991897eaf237cc97efa9dc5c1.svg";
export { ForwardRef as ReactComponent };